import { render, staticRenderFns } from "./editAccountModal.vue?vue&type=template&id=b18a12fa&scoped=true"
import script from "./editAccountModal.vue?vue&type=script&lang=js"
export * from "./editAccountModal.vue?vue&type=script&lang=js"
import style0 from "./editAccountModal.vue?vue&type=style&index=0&id=b18a12fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18a12fa",
  null
  
)

export default component.exports